import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function NotFoundPage(): JSX.Element {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4">
      <div className="text-4xl font-bold">404</div>
      <div className="text-sm text-muted-foreground">That cockpit surface does not exist.</div>
      <Button asChild>
        <Link to="/queue">Back to queue</Link>
      </Button>
    </div>
  );
}
